var wcmContent = {
  "specialty_ach_renewal": {
    "specialty_ach_renewal_cvs": "Do you wan to continue to allow CVS/specialty to debit directly from your pchecking account ending in",
    "specialty_ach_renewal_cvs_payment": "for the purpose of bill payment?",
    "specialty_ach_renewal_cvs_continue": "Yes, continue to withdraw"
  },
  "specialty_autopay_banner": {
    "specialty_autopay_banner_once_a_month": "Once a month, we can automatically charge for the full balance up to a limit you set.",
    "specialty_autopay_banner_setup_auto_payments": "Set up automatic payment"
  },
  "specialty_acc_summary": {
    "specialty_acc_summary_every": "the",
    "specialty_acc_summary_month": "of every month",
    "specialty_acc_summary_bal_accrued": "the full balance as soon as it accrues",
    "specialty_acc_summary_edit": "Edit",
    "specialty_acc_summary_selectpaymentmethod": "Select a different payment method",
    "specialty_acc_summary_selectpaymentamount": "Edit payment amount",
    "specialty_acc_summary_never_change": "Charge me up to "
  },
  "specialty_available_refills_info": {
    "specialty_available_refills_info_next": "Next Setps",
    "specialty_available_refills_info_quick": "Quick registration",
    "specialty_available_refills_info_prescription": "Prescriptions to refill"
  },
  "specialty_bank_info": {
    "specialty_bank_info_first_name_acc": "First name on account",
    "specialty_bank_info_last_name_acc": "Last name on account",
    "specialty_bank_info_check": "Bank account information on a check.",
    "specialty_bank_info_routing_number": "Routing number",
    "specialty_bank_info_nine_digit_number": "A 9 digit number at the lower left corner of a check. Contact your bank if you need help.",
    "specialty_bank_info_acc_number": "Account number",
    "specialty_bank_info_digit_number": "A 3-16 digit number at the bottom of a check or on a bank statement. Contact your bank if you need help.",
    "specialty_bank_info_relationship_bank_acc_owner": "Relationship to bank account owner",
    "specialty_bank_info_select_state": "Please select a state",
    "specialty_bank_info_select_relationship": "Select Relationship",
    "specialty_bank_info_self_patient": "SELF (PATIENT)",
    "specialty_bank_info_parent": "PARENT",
    "specialty_bank_info_other": "OTHER"
  },
  "specialty_billing_address": {
    "specialty_billing_address_street_address": "Street address line 1",
    "specialty_billing_address_street_address_two": "Street address line 2 (optional)",
    "specialty_billing_address_city": "City",
    "specialty_billing_address_state": "State",
    "specialty_billing_address_zip": "ZIP code"
  },
  "specialty_billing_address_selection": {
    "specialty_billing_address_selection_primary_address": "Use primary address on file",
    "specialty_billing_address_selection_new_address": "Enter a new billing address",
    "specialty_billing_address_city": "City",
    "specialty_billing_address_state": "State",
    "specialty_billing_address_zip": "ZIP code"
  },
  "specialty_billing_card_info": {
    "specialty_billing_card_info_card_number": "Card number ",
    "specialty_billing_card_info_accept": "We accept these credit, debit, FSA and HSA cards",
    "specialty_billing_card_info_copay": "You may not use a copay assistance or drug manufacturer's credit card to pay your balance online. If you'd prefer to use one of those payment methods, ",
    "specialty_billing_card_info_first_name_card": "First name on card",
    "specialty_billing_card_info_last_name_card": "Last name on card",
    "specialty_billing_card_info_exp_date": "Expiration date",
    "specialty_billing_card_info_year": "Year",
    "specialty_billing_card_info_show": "Show",
    "specialty_billing_card_info_hide": "Hide"
  },
  "specialty_current_balance": {
    "specialty_current_balance_header": "Balance"
  },
  "specialty_export_payment_history": {
    "specialty_export_payment_history_header": "Save or print payment history",
    "specialty_export_payment_history_header_mapp": "View payment history",
    "specialty_export_payment_history_export": "Export your payment history for personal records or taxes.",
    "specialty_export_payment_history_date_range": "Select date range",
    "specialty_export_payment_history_year_to_date": "YTD",
    "specialty_export_payment_history_fiscal_year_to_date": "Last year",
    "specialty_export_payment_history_custom_date_range_2016": "Past 12 months",
    "specialty_export_payment_history_custom_date_range_2015": "Past 24 months",
    "specialty_export_payment_history_custom_date_range": "Custom date range",
    "specialty_export_payment_history_select_month": "Select month",
    "specialty_export_payment_history_hide_drug_names": "Hide drug names",
    "specialty_export_payment_history_save_print": "Save/print PDF",
    "specialty_export_payment_history_save_csv": "Save as CSV file"
  },
  "specialty_payment_history": {
    "section_header": "VIEW PAYMENT HISTORY",
    "section_intro": "See all your past specialty prescription payments. Your account activity for the last past three months is shown automatically, but you may view up to 24 months.",
    "section_detail": "See all your past specialty prescription payments. Your account activity for the last past three months is shown automatically, but you may view up to 24 months.",
    "rest_content": "",
    "specialty_payment_history_header": "Payment History",
    "specialty_payment_history_no_results_found": "No results found."
  },
  "specialty_payment_methods": {
    "specialty_payment_methods_header": "Saved payment methods",
    "specialty_payment_methods_expired": "(Expired)",
    "specialty_payment_methods_edit": "Edit",
    "specialty_payment_methods_see_more_saved": "Show more saved payment methods",
    "specialty_payment_methods_see_fewer_saved": "Hide saved payment methods",
    "specialty_payment_methods_no_saved_method": "No Saved Payment methods on file",
    "specialty_payment_methods_card_expired": "Credit card has expired"
  },
  "specialty_payment_break_down": {
    "specialty_payment_break_down_paynow": "Today's payment:",
    "specialty_payment_amount": "$0.00"
  },
  "specialty_next_steps": {
    "specialty_next_steps_header": "Next Steps",
    "specialty_next_steps_why": "Why activate your account?",
    "specialty_next_steps_auto_payments": "You can set up automatic payments, view or save your payment history, refill prescriptions and track prescription shipments.",
    "specialty_next_steps_activate_account": "Activate account now",
    "specialty_next_steps_refill": "Refill prescriptions",
    "specialty_next_steps_prescription": "prescription(s) ready for refill.",
    "specialty_next_steps_refill_now": "Refill now"
  },
  "specialty_nonreg_payment": {
    "confirm_identity_header": "<strong>Confirm your identity</strong>",
    "confirm_identity_intro": "For your security, we need to verify your identity before you can view your balance and make a payment.",
    "confirm_identity_refill_body": "Before you can access your refill information, you must register. It only takes a few minutes now and will save you time later.",
    "link_lockout_header": "",
    "guest_pymnt_promo_content": "If you activate your CVS Specialty account, you can also:</br>\n• Set up automatic payments</br>\n• View, download and print your payment history</br>\n• Refill prescriptions</br>\n• Track prescription shipments</br>\n\nAccount activation takes about 5 minutes. Or you can skip activation and just make a payment.",
    "agent_disclaimer_content": "If the message or email that brought you here was not addressed to you, or you do not have a licensed power of attorney for\nthe person to whom it was addressed, you may not continue.",
    "link_lockout_intro": "We're sorry, but you have tried to verify your identity too many times. For security purposes, access to pay your balance has been locked. <a href=\"/wps/portal/specialty/patients/registration\">Register for an account</a> to pay online, or call Billing toll-free at 1-800-250-9631 to pay by phone.",
    "rest_content": "",
    "confirm_identity_reg_reminder_body": "Why haven't you registered for a convenient online account? It only takes a few minutes and you can begin managing your CVS/specialty prescriptions online. Simply complete the information below and click the continue button to register. Or you can skip registration and just track your package.",
    "confirm_identity_register_pay": "Activate account  & pay",
    "confirm_identity_continue": "Continue",
    "confirm_identity_register_track": "Register and Track",
    "track_as_package": "Track a Package Only",
    "confirm_identity_or": "OR",
    "confirm_identity_make_payment_only": "Make a payment only >",
    "confirm_identity_dob": "Date of Birth",
    "confirm_identity_zipcode": "ZIP Code",
    "confirm_identity_showInvalidDataError": "The date of birth and ZIP code you entered do not match our records. Please check that you entered the correct information. Call us toll-free at <strong>1-800-237-2767</strong><span>(TTY: 711)</span> if you need help. ",
    "confirm_identity_view_balance": "In order to access to view your balance and make a payment, you first need confirm your identity.",
    "confirm_indetity_additional_register": "Additionaly you can register now to",
    "confirm_identity_auto_payments": "Set up automatic payments",
    "confirm_identity_payment_info": "Save payment information for future use",
    "confirm_identity_view_download": "View, download, and print your payment history",
    "confirm_identity_skip_registration": "Simply complete the information below and click the continue button to register. Or you can skip registration and just track your package. Registration takes about 5 minutes",
    "confirm_identity_track_as_package": "<strong>Note:</strong> you may still track your package after completing registration",
    "confirm_identity_disclaimer": "If the message or email that brought you here was not addressed to you, or you do not have a licensed power of attorney for the person to whom it was addressed, you may not continue."
  },
  "specialty_recurring_payment": {
    "setup_modal_intro": "Choose how much you want to pay and when to pay it. We will not bill more than your chosen limit, even if your balance exceeds it.",
    "rest_content": "",
    "section_header": "MANAGE REPEATING PAYMENTS",
    "section_intro": "Create or update a repeat payment schedule here. You can choose the amount and the timing of payments. You can activate, deactivate or switch schedules as needed based on your finances.",
    "credit_balance": "<strong>You have a credit balance. </strong>Call Billing toll-free at 1-800-250-9631 to be reimbursed. The credit will not be automatically applied to your account.",
    "section_intro_pleasenote": "<strong>Please note: </strong>You can only edit the active payment schedule.",
    "section_tooltip": "You can choose the amount and the timing of payments as well as the payment method. Activate, deactivate or switch schedules as needed based on your finances.",
    "section_intro_open": "Create or update a repeat payment schedule here. You can choose the amount and the timing of payments. You can activate, deactivate or switch schedules as needed based on your finances.",
    "section_intro_open_pleasenote": "<strong>Please note:You can only edit the active payment schedule.</strong>",
    "activate_modal_headline": "ACTIVATE REPEATING PAYMENT",
    "activate_modal_intro": "When you reactivate an existing payment, you must re-enter the maximum payment amount and frequency. Choose continue to make these edits, or cancel to return to your previous settings.",
    "setup_modal_headline": "SET UP A REPEATING PAYMENT",
    "specialty_recurring_payment_balance": "You can schedule payment on a specific day every month for either the full balance or an amount specified by you.",
    "duplicate_modal_headline": "Set up automatic payments",
    "duplicate_modal_intro": "You already created a repeating payment with this payment method. Choose continue to keep your new billing limit and timing, or cancel to use a different payment method.",
    "recredit_statement": "<strong>You have a credit balance.</strong> Call Billing toll-free at 1-800-250-9631 to be reimbursed. The credit will not be automatically applied to your account.",
    "threshold_tooltip": "This is the maximum amount you will allow us to charge or withdraw. If your balance exceeds this limit, we'll call you about the outstanding amount.",
    "frequency_tooltip": "Choose which day of the month to make a payment. If you use a credit card, you may also choose to pay immediately—as soon as a charge hits your account.",
    "reaccepted_method": "You may not use a copay assistance or drug manufacturer's credit card to pay your balance online. If you'd prefer to use one of those payment methods, please call Billing toll-free at 1-800-250-9631.",
    "auto_pay_header_content": "Review automatic payments",
    "pymt_submtd_header_content": "<strong>Payment submitted</strong>",
    "pymt_submit_success": "Please allow 24 to 48 hours for the payment to be processed.",
    "autopay_header_content": "<strong>Automatic payments set up</strong>",
    "pamnt_enabled_success": "You set up automatic payments.",
    "pmnt_scheduled_success": "Please allow 24 to 48 hours for your payment to process. <br > Your automatic payment has also been set up.",
    "auto_pay_suspended": "<b>Automatic payments have been suspended!</b> <br>We need updated approval from you to continue withdrawing funds on your behalf for automatic bill pay. For your security, we need proof of this permission every 3 years.",
    "auto_payment_reauth": "Do you want to continue to allow CVS Specialty™ to withdraw directly \nfrom the account below for the purpose of bill payment?",
    "max_threshold_value": "In the future, if your balance exceeds this limit, we'll call you about the outstanding amount.",
    "pamnt_enabled_success_content": "<strong>Success!</strong><br>\nYou set up automatic payments."
  },
  "specialty_bank_account_info": {
    "specialty_bank_account_info_header": "Add New Bank Account",
    "specialty_bank_account_info_edit_bank_acc": "Edit Bank Account",
    "specialty_bank_account_info_payment_method": "Payment Method Information",
    "specialty_bank_account_info_billing_address": "Billing address",
    "specialty_bank_account_info_save_continue": "Save &amp; continue",
    "specialty_bank_account_info_back": "Back",
    "specialty_bank_account_info_disclaimer": "You may not use a copay assistance or drug manufacturer's credit card to pay your balance online. If you'd prefer to use one of those payment methods, please "
  },
  "specialty_confirm_id": {
    "specialty_confirm_id_confirm_identity": "Confirm your identity",
    "specialty_confirm_id_order_identity": "In order to access your balance and make a payment, you first need to confirm your identity.",
    "specialty_confirm_id_register": "Additionally, you can register now to",
    "specialty_confirm_payment_automatic_payment_settings": "Set up automatic payments",
    "specialty_confirm_payment_automatic_payment_save_payment": "Save payment information for future use",
    "specialty_confirm_payment_automatic_payment_view_download": "View, download, and print your payment history",
    "specialty_confirm_id_simply_complete_info": "Simply complete the information below and click the continue button to register. Or you can skip registration and just track your package. Registration takes about 5 minutes.",
    "specialty_confirm_id_dob": "Date of Birth",
    "specialty_confirm_id_zip_code": "Zip Code",
    "specialty_confirm_id_register_pay": "Register &amp; Pay",
    "specialty_confirm_id_payment_only": "Make payment only<"
  },
  "specialty_confirm_payment": {
    "specialty_confirm_payment_automatic_payments_enabled": "Automatic payments enabled",
    "specialty_confirm_payment_automatic_payment_submitted": "Payment submitted",
    "specialty_confirm_payment_automatic_payment_disclaimer": "*This amount does not reflect orders that have not been shipped, that are pending insurance payment or that have been sent to an outside collections agency.",
    "specialty_confirm_payment_automatic_payment_settings": "Automatic Payment Settings:",
    "specialty_confirm_payment_eff_date": "Effective Date",
    "specialty_confirm_payment_save_print_pdf": "Save/Print PDF",
    "specialty_confirm_payment_return_to_acc": "Return to Account Balance &amp; Payment",
    "specialty_make_payment_partial_payment_amount": "Payment Amount:",
    "specialty_make_payment_one_third": "Must be at least 1/3 total balance",
    "specialty_make_payment_total_balance": "Can't exceed the total balance ",
    "specialty_make_payment_auto_payments": "Set up automatic payments",
    "specialty_make_payment_balance": "As soon as you have a balance, we can automatically deduct the total, up to a limit that you set.",
    "specialty_make_payment_continue": "Continue",
    "specialty_make_payment_acc_bal_disclaimer": "*This amount does not reflect orders that have not been shipped, that are pending insurance payment or that have been sent to an outside collections agency.",
    "confirm_info_notice": "Please note: It may take a few days for the charge to be processed and reflected in your account balance. You will receive a receipt with the payment confirmation number by U.S. mail."
  },
  "specialty_make_payment": {
    "specialty_make_payment_section_header": "<strong>Make a payment</strong>",
    "partial_payment_instruction": "",
    "specialty_make_payment_acc_bal_disclaimer": "*This amount does not reflect orders that have not been shipped, that are pending insurance payment or that have been sent to an outside collections agency.",
    "section_intro": "Choose a payment amount and method. You'll have the option to set up a repeating payment once your specialty prescriptions account balance has been paid in full.",
    "partial_payment_tooltip": "A partial payment must equal at least one-third of your balance. If you can't pay that amount, please call Billing toll-free at 1-800-250-9631.",
    "new_payment_tooltip": "You must enter a payment method before you can pay your account balance.",
    "payment_body": "",
    "payment_confirm_intro": {
      "p": {
        "_dir": "ltr",
        "__text": "Review your payment information before submitting it. Go back to make any needed changes."
      }
    },
    "payment_thankyou_intro": "Your payment has been scheduled. It may take a few days for the charge to be processed and reflected in your account balance. You will receive a receipt with the payment confirmation number by U.S. mail. \n<br/>\n<strong>Did you have a repeating payment set up? </strong>If so, it has been deactivated by this one-time payment. Once this transaction has been processed, you'll need to reactivate your repeating payment.",
    "payment_balance_disclaimer": "I understand that the above balance does not reflect orders that have not been shipped, that are pending insurance payment or that have been sent to an outside collections agency.",
    "specialty_account_payment_method_sub_header": "Add a payment method",
    "specialty_account_payment_method_add_new": "Add new bank account",
    "specialty_account_payment_method_add_new_debit": "Add new credit/debit /HSA/FSA card",
    "saved_mop_subhead_content": "<b>Saved payment methods</b>",
    "addbank_acct_header": "<b>Add a bank account</b>",
    "editbank_acct_header": "<b>Edit a bank account</b>",
    "routing_number_note": "This is the 9-digit number located on the lower left corner of your checks. Contact your bank if you need help.",
    "acct_number_note": "This is the 3-16 digit number located to the right of the routing number your checks. If can also find it on your bank statements. Contact your bank if you need help.",
    "add_card_header": "<b>Add a card</b>",
    "edit_card_header": "<b>Edit a card</b>",
    "review_pamnt_header": "<b>Review payment</b>",
    "direct_debit_content_disclosure": "I authorize CVS Specialty™ to debit directly from my checking or savings account for the purpose of bill payment.",
    "specialty_account_payment_method_header": "<strong>Select a payment method</strong>",
    "specialty_manage_payment_method_header": "<strong>Manage payment methods</strong>"
  },
  "specialty_account_bal_payment": {
    "specialty_account_bal_payment_section_header": "<strong>Account balance and payment</strong>",
    "payment_global_error_header": "",
    "payment_global_error_intro": "",
    "payment_have_questions": "If you have questions, please <a href=\"/wps/portal/specialty/company/faq\" faq id=\"faqlinkfrompayments\" >read our frequently asked questions</a>. If you prefer to make a payment by phone, please call Billing toll-free at </br><a href='tel:+1-800-250-9631'>1-800-250-9631</a> <span>(TTY: 711)</span>.",
    "rest_content": "",
    "specialty_account_bal_payment_make_payment_now": "Make Payment Now",
    "specialty_account_bal_payment_disclaimer": "*This amount does not reflect orders that have not been shipped, that are pending insurance payment or that have been sent to an outside collections agency.",
    "specialty_account_bal_payment_make_onetime_payment_now": "Make a one-time payment",
    "specialty_account_bal_payment_switch_onetime_payment": "Deactivate Automatic Payments",
    "specialty_account_bal_payment_auto_payments": "Set Up Automatic Payments",
    "specialty_account_bal_payment_sorry_message": "We're Sorry.",
    "specialty_account_bal_payment_payment_error": "There is 1 error in the form below.",
    "specialty_account_bal_payment_make_payment_auto": "Auto Payment amount must be at least your total balance",
    "specialty_account_bal_payment_balance_accrued": "As soon as I have a balance accrued",
    "specialty_account_bal_payment_fsa": "If you entered a FSA card as your payment method, this option will default to charging every",
    "specialty_account_bal_payment_date": "On a specific date each month",
    "specialty_account_bal_payment_limit": "If your balance is over this limit, we will charge the limit, then call to resolve the difference.",
    "specialty_account_bal_payment_charge": "Never charge me more than",
    "pymt_note_content": "We can schedule a payment on a specific day every month for either the full balance or an amount specified by you. ",
    "pymt_auth_content": "<b>Pending payment</b><br>Until any pending payments are processed, we can't accept additional payments or help you set up automatic payments.",
    "pymt_subhead_content": "Interested in automatic payment? ",
    "partial_payment_instruction": [],
    "new_payment_tooltip": "You must enter a payment method before you can pay your account balance.",
    "payment_body": [],
    "payment_confirm_intro": "Review your payment information before submitting it. Go back to make any needed changes.",
    "payment_thankyou_intro": "Your payment has been scheduled. It may take a few days for the charge to be processed and reflected in your account balance. You will receive a receipt with the payment confirmation number by U.S. mail. <br/><strong>Did you have a repeating payment set up? </strong>If so, it has been deactivated by this one-time payment. Once this transaction has been processed, you'll need to reactivate your repeating payment.",
    "payment_balance_disclaimer": "I understand that the above balance does not reflect orders that have not been shipped, that are pending insurance payment or that have been sent to an outside collections agency.",
    "auto_pymt_subhead_content": "Interested in automatic payment?",
    "auto_pymt_note_content": "We can schedule a payment on a specific day every month for either the full balance or an amount specified by you."
  },
  "specialty_payment_card_info": {
    "specialty_payment_card_info_add_new_credit_card": "Add New Credit Card",
    "specialty_payment_card_info_edit_new_credit_card": "Edit Credit Card",
    "specialty_payment_card_info_add_payment_method_header": "Payment Method Information",
    "specialty_payment_card_info_billing_address": "Billing Address",
    "specialty_payment_card_info_save_continue": "Save &amp; continue",
    "specialty_payment_card_info_cancel": "Back",
    "specialty_payment_card_info_disclaimer": "You may not use a copay assistance or drug manufacturer's credit card to pay your balance online. If you'd prefer to use one of those payment methods, please call Billing toll-free at 1-800-250-9631.",
    "specialty_account_review_payment_make_payment": "&nbsp;to Make a payment"
  },
  "specialty_account_payment_method": {
    "specialty_account_payment_method_header": "Select a payment method",
    "specialty_account_payment_method_sub_header": "Add a payment method",
    "specialty_account_payment_method_add_new": "Add new bank account",
    "specialty_account_payment_method_add_new_address": "Add new address",
    "specialty_account_payment_method_add_new_debit": "Add new credit/debit/FSA/HSA card",
    "specialty_account_payment_method_bank_account": "Bank Account",
    "specialty_account_payment_method_debit": "Credit/Debit/FSA/HSA Card",
    "specialty_account_review_payment_continue": "Continue",
    "specialty_account_review_payment_back": "Back",
    "specialty_account_review_payment_make_payment": "&nbsp;to Make a payment",
    "specialty_account_review_payment_myaccount": "&nbsp;to My Account"
  },
  "specialty_account_review_payment": {
    "specialty_account_review_payment_automatic": "automatic",
    "specialty_account_review_payment_text": "payments",
    "specialty_account_review_payment_header": "Automatic Payment Settings:",
    "specialty_account_review_payment_ack": "*I acknowledge that the current balance amount may not reflect orders that have not been shipped, that are pending insurnace payment or that have been sent to an outside collections agency.",
    "specialty_account_review_payment_debit": "*Allow CVS/specialty to debit directly from your checking account for the purpose of bill payment?",
    "specialty_account_review_payment_print": "Save/print this ACH disclosure",
    "specialty_account_review_payment_eff_date": "Effective Date:",
    "specialty_account_review_payment_back": "Back",
    "specialty_account_review_payment_submit": "Submit"
  },
  "specialty_help": {
    "rest_content": "",
    "cc_payment_pleasenote": "You may not use a copay assistance or drug manufacturer's credit card to pay your balance online. If you'd prefer to use one of those payment methods, please call Billing toll-free at 1-800-250-9631.",
    "payment_approval_pleasenote": "We will call you for approval each time before withdrawing funds from your bank account.",
    "dormant_utility_spot": "",
    "nonprd_public_key": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA081yJhOc6/806qHe8AzDDAtjWKPcktf3fsng0bahqjABgDh9M+EIwbgxYsyBoMdbZI3hP02COwISEWFneFaxIB6dRLzpZQdmAdg4Y3+yx/IRD7TfmnanxVDVddgS186X4Clx/+tp9y1UKhkNVPyHR9S0uKjXEOYk6UibztMf70mpGkTsxdFIDK+bvHrCYMqka60gODJaSiL5/s8A+h3deOOR3qIC6+ut24gbUY5aTyHMxaA86smRrwk/caHYwNWj7tzUG5sdQhoKD1QMKcv9gZ1USSyaNY4pjDKa9PUgqf9vlIfUK56B5DFEjl28t+ZpkPvddL/dp1lydT9d8Aq9VQIDAQAB",
    "prd_public_key": {
      "p": {
        "_dir": "ltr",
        "__text": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvxad9fNU+OWqdE0dLoiF9ED2eINoqwO+bEALmC88H6zeYTHogNYOVMTVLKSH9rxIsWUjxuzU7o6Zd4hcKHgkeLhjw3NdISgruL//fb1s6egVJIjQwMe/L/Pfo1EDcHVRLEKLEbqAR3IfMXuXVEAgxbm/VMbt5IUI2DgXGqv/fNHxzPBq9bYm2dxLe/OZNlcz7doMp6kNBPIAoabQG0VEvhxZtme1mcbn8NY0wuQkomfvGk8+Sx8zEPg1hPZbiwUuWeOMWg3yLlLdrl3QnGLLvj+kJEmQgcETWwbAy+hS21vXFbMExfggGucNW4mJ+3sVJMUS8vFCmWL8EGxs7dHz8wIDAQAB"
      }
    },
    "allow_multiple_payments": "N",
    "Disclaimer": "ACH Disclosure",
    "authorize_pdf_para_one": "I hereby authorize CVS to initiate a single or recurring charge(s) or debit(s), as applicable, to my credit or debit card listed below to pay co-pays for the medication that I order through CVS/specialty.",
    "authorize_pdf_para_two": "I understand that the charge(s) or debit(s) will occur today in the amount of $",
    "authorize_pdf_para_three": "or, for recurring charges and debits, on the",
    "authorize_pdf_para_four": "of each month, in an amount not to exceed $",
    "authorize_pdf_para_five": "If I am authorizing recurring payments, I acknowledge and understand that I will not receive any pre-notification of such debit(s) or charge(s) unless the day of the month changes or the debit or charge is in excess of the maximum amount specified above, in which case I will receive notice at least 10 days prior to the charge or debit.",
    "authorize_pdf_para_six": "I understand that if my card is declined, CVS may continue to request the charge or debit until funds are available and the payment has been posted to my account. I understand and acknowledge that this authorization will remain in full force and effect unless and until I revoke it by providing express written notice of revocation to CVS at the following address",
    "authorize_pdf_para_seven": "and that such notice must be received by CVS no later than the 15th day of the month to be effective for the subsequent month.",
    "bank_acc_ending": "Bank Account Number ending with",
    "authorize_pdf_para_eight": "To complete the payment authorization process, please click the ・€・authorize・€・ button below. It is recommended that you print a copy of this authorization and maintain it for your records.",
    "printed_on": "Printed on:",
    "corporate_address": "1 CVS Drive, Woonsocket, RI 02895",

    "ach_Disclaimer": "ACH / Credit Card Payment Disclosure",

    "ach_pdf_payment_info_1": "Payment information:",
    "ach_pdf_payment_info_2": "Bank account ending in ",

    "ach_pdf_payment_amount_1": "Payment amount today:",
    "ach_pdf_payment_amount_2": "$",

    "ach_pdf_autopayment_amount_1": "Auto Payment amount:",
    "ach_pdf_autopayment_amount_2": "$",

    "ach_pdf_contact_info_1": "Contact information:",
    "ach_pdf_contact_info_2": "Express written notice of revocation to CVS Specialty at",
    "ach_pdf_contact_info_3": "PO Box 99778 Chicago, Illinois, 60696, or call 800-250-9631 (TTY: 711)",

    "ach_pdf_para_four": "I hereby authorize CVS Specialty to initiate a single or recurring charge(s) or debit(s), as applicable, to my ACH bank account, credit card, or debit card listed below to pay co-pays, deductibles or out-of-pocket expenses payable to CVS Specialty for the medication that I order through CVS Specialty (“Patient Cost Share”), and to store my payment method for future payments (“Card/Account on File”).",
    "ach_pdf_para_five_1": "I authorize CVS Specialty to charge or debit my Card/Account on File ending in ",
    "ach_pdf_para_five_2": " today in the amount of $",
    "ach_pdf_para_five_3": " for my Patient Cost Share or, for recurring charges and debits, on the 24th of each month when there is a balance due for my Patient Cost Share, in an amount not to exceed $",
    "ach_pdf_para_five_4": " I understand that because these are electronic transactions, these funds may not be initiated from my Card/Account on File until the next billing day.",
    "ach_pdf_para_six": " For credit or debit card payments, I understand that, if my card is linked to a Health Savings Account (“HSA”) or Flexible Savings Account (“FSA”), I should only list patients for whom payment may be made from my HSA or FSA account, pursuant to the terms of my health insurance plan.",
    "ach_pdf_para_seven": "For recurring payments, I acknowledge and understand that I will not receive any pre-notification of such debit(s) or charge(s) unless the day of the month changes or the debit or charge is in excess of the maximum amount specified above, in which case I will receive notice at least 10 days prior to the charge or debit.  I understand that if I fail to maintain a valid Card/Account on File at any time the full Patient Cost Share owed by me becomes immediately payable.",
    "ach_pdf_para_eight_1": "I understand that if my card is declined, CVS Specialty may continue to request the charge or debit until funds are available and the payment has been posted to my account. I understand and acknowledge that this authorization will remain in full force and effect unless and until I revoke it by providing express written notice of revocation to CVS Specialty at the following address ",
    "ach_pdf_para_eight_2": "PO Box 99778 Chicago, Illinois, 60696",
    "ach_pdf_para_eight_3": " or by calling ",
    "ach_pdf_para_eight_4": "800-250-9631(TTY: 711)",
    "ach_pdf_para_eight_5": " and that such notice must be received by CVS Specialty no later than the 15th day of the month to be effective for the subsequent month.  I understand that a revocation will not apply to any charges or transactions that occurred before the date of revocation.  CVS Specialty may cancel my participation in the Card/Account on File service at any time, for any reason, in its sole discretion.",
    "ach_pdf_para_nine": "I authorize CVS Specialty to disclose my health information to any person as required to respond to and resolve a payment dispute relating to the Card/Account on File service. This authorization is limited to the health information necessary to respond to and resolve a payment dispute, including information relating to any medication I receive in connection with the Card/Account on File service and shall be in force and effect while I participate in the Card/Account on File service. I understand that if I do not authorize the disclosure described in this section my health care will not be affected; however, I will not be able to participate in the Card/Account on File service.",
    "ach_pdf_para_ten": "I understand that California law prohibits the recipient of my health information from making further disclosures of it without obtaining an additional authorization from me, except in cases in which a further disclosure is permitted or required by law. However, if the recipient of my health information is not located in California, I understand that the information used or disclosed pursuant to this authorization may be subject to re-disclosure by the recipient and may no longer be protected by federal law or by the law of the state in which the recipient is located.",
    "ach_pdf_para_eleven": "It is recommended that you print or download a copy of this authorization and maintain it for your records."
  },
  "identity_unauth": {
    "identity_disclaimer": "If the message or email that brought you here was not addressed to you, or you do not have a licensed power of attorney for the person to whom it was addressed, you may not continue.",
    "identity_header": "Confirm your identity",
    "identity_intro": "Please enter your date of birth and ZIP code below. Caregivers: please enter your patient's information below.",
    "identity_timeout_body": "Your session will end in two minutes. If you need more time, please click the continue button.",
    "identity_timeout_header": "Do You Need More Time?",
    "identity_refill_body": "Before you can access your refill information, you must register. It only takes a few minutes now and will save you time later.",
    "reg_reminder_body": "Why haven't you registered for a convenient online account? It only takes a few minutes and you can begin managing your CVS/specialty prescriptions online. Simply complete the information below and click the continue button to register. Or you can skip registration and just track your package."
  },
  "qr_unauth": {
    "reg_reminder_body": "Why haven’t you registered for a convenient online account? It only takes a few minutes and you can begin managing your CVS Specialty prescriptions online. Simply complete the information below and click the continue button to register. Or you can skip registration and just track your package.",
    "form_intro": "CVS Specialty patients: you can sign up for online access, which makes it even easier to manage your care.<br /> <br /> Not a CVS Specialty patient? Call toll-free <strong>1-800-237-2767</strong><span>(TTY: 711)</span> to get started.",
    "form_all_fields_req": "All fields below are required.",
    "terms_check": "I agree to the CVS Specialty <a href=\"/wps/portal/specialty/company/terms-and-conditions\" rel=\"noopener noreferrer\" target=\"_blank\">terms and conditions</a>.",
    "remember_email_check": "Remember me on this device.<br/>Note: Please choose this option only if you're on a private device.",
    "reg_success_header": "Congratulations!",
    "reg_success_body": "You have successfully registered. You may now easily track your prescriptions and stay on top of your care.",
    "reg_rightrail_security": "<h2>Security Question Tips</h2> <div id=\"accordion-faq\"> <ul> <li><span class=\"accordion-faq-toggle\">Select two questions and provide accurate answers.</span></li> <li><span class=\"accordion-faq-toggle\">You may be asked to answer these questions in the future to confirm your identity.</span></li><li><span class=\"accordion-faq-toggle\">Your security answer can't match your username or password.</span></li></ul> </div>",
    "reg_rightrail_needhelp": "<h2>Need Help?</h2> <p>For website support, call toll-free <br/>1-855-264-3239</p>",
    "remember_email_check_title": "Remember my email on this computer",
    "remember_email_check_note": "Note: Please choose this option only if you're on a private device.",
    "remember_me_select_title": "Selecting Remember Me",
    "remember_me_select_descritpion": "You have the opportunity to select Remember Me when you sign in to your existing account.<br/><br/>When you opt in, we'll make it easier to sign in by prepopulating your username in the user field. When you select Remember Me, you'll still need to sign in to your account to refill prescriptions, check order status and manage your profile.<br/><br/> <b> Who shouldn't opt in: </b><br/><br/>We do not recommend this feature if you're using a public or shared computer or mobile phone.<br/><br/>When you select Remember Me, you ask CVSSpecialty.com to give you a more personalized experience by installing a cookie on your device."
  },
  "specialty_unauth_make_payment": {
    "section_header": "Make a Payment",
    "section_intro": "Choose a payment amount and method. You'll have the option to set up a repeating payment once your specialty prescriptions account balance has been paid in full.",
    "section_pleasenote": "<strong>Please note:</strong> This amount does not reflect orders that have not been shipped, that are pending insurance payment or that have been sent to an outside collections agency.",
    "partial_payment_tooltip": "A partial payment must equal at least one-third of your balance. If you can't pay that amount, please call Billing toll-free at 1-800-250-9631.",
    "partial_payment_instruction": "",
    "new_payment_tooltip": "You must enter a payment method before you can pay your account balance.",
    "payment_body": "",
    "payment_confirm_intro": {
      "p": {
        "_dir": "ltr",
        "__text": "Review your payment information before submitting it. Go back to make any needed changes."
      }
    },
    "payment_thankyou_intro": "<strong>Please note:</strong> It may take a few days for the charge to be processed and reflected in your account balance. You will receive a receipt with the payment confirmation number by U.S. mail.",
    "payment_balance_disclaimer": "I understand that the above balance does not reflect orders that have not been shipped, that are pending insurance payment or that have been sent to an outside collections agency.",
    "payment_have_questions": {
      "a": {
        "_href": "/wps/portal/specialty/company/faq",
        "_title": "Read our frequently asked questions",
        "_target": "_blank",
        "__text": "read our frequently asked questions"
      },
      "__text": "If you have questions, please \n.nbsp"
    },
    "activate_acct_promo": "You can set up automatic payments, view or save your payment history, refill prescriptions and track prescription shipments.",
    "pending_payment": "<strong>Pending payment</strong><br/>\nUntil any pending payments are processed, we can't accept additional payments or help you set up automatic payments.",
    "unauth_bank_account": "Bank Account",
    "unauth_pymt_card": "Credit/debit/HSA/FSA card"
  },
  "fast_config": {
    "component_config": {
      "config": [{
        "componentname": "QR",
        "componentversion": "1.0",
        "channelswitches": {
          "mobileweb": "Y",
          "mobileapp": "Y",
          "desktop": "Y"
        },
        "loglevel": {
          "info": "false",
          "debug": "false",
          "trace": "false",
          "error": "false"
        }
      },
      {
        "componentname": "Registration",
        "componentversion": "1.0",
        "channelswitches": {
          "mobileweb": "Y",
          "mobileapp": "Y",
          "desktop": "Y"
        },
        "loglevel": {
          "info": "true",
          "debug": "true",
          "trace": "true",
          "error": "true",
          "warn": "true",
          "fatal": "true"
        }
      },
      {
        "componentname": "OLP",
        "componentversion": "1.0",
        "channelswitches": {
          "mobileweb": "Y",
          "mobileapp": "Y",
          "desktop": "Y"
        },
        "loglevel": {
          "info": "true",
          "debug": "true",
          "trace": "true",
          "error": "true"
        }
      },
      {
        "componentname": "RFR",
        "componentversion": "1.0",
        "channelswitches": {
          "mobileweb": "Y",
          "mobileapp": "Y",
          "desktop": "Y"
        },
        "loglevel": {
          "info": "false",
          "debug": "false",
          "trace": "false",
          "error": "false"
        }
      },
      {
        "componentname": "GR",
        "componentversion": "1.0",
        "channelswitches": {
          "mobileweb": "Y",
          "mobileapp": "Y",
          "desktop": "Y"
        },
        "loglevel": {
          "info": "true",
          "debug": "true",
          "trace": "true",
          "error": "true"
        }
      },
      {
        "componentname": "MyHelathPromo",
        "componentversion": "1.0",
        "channelswitches": {
          "mobileweb": "Y",
          "mobileapp": "N",
          "desktop": "Y"
        },
        "loglevel": {
          "info": "true",
          "debug": "true",
          "trace": "true",
          "error": "true"
        }
      },
      {
        "componentname": "epic",
        "componentversion": "1.0",
        "channelswitches": {
          "mobileweb": "y",
          "mobileapp": "y",
          "desktop": "y"
        },
        "loglevel": {
          "info": "true",
          "debug": "true",
          "trace": "true",
          "error": "true"
        }
      },
      {
        "componentname": "dual_hbs",
        "componentversion": "1.0",
        "channelswitches": {
          "mobileweb": "y",
          "mobileapp": "y",
          "desktop": "y"
        },
        "loglevel": {
          "info": "true",
          "debug": "true",
          "trace": "true",
          "error": "true"
        }
      }
      ]
    }
  },
  "state": {
    "AL": "Alabama",
    "AK": "Alaska",
    "AS": "American Samoa",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "DC": "District Of Columbia",
    "FM": "Federated States Of Micronesia",
    "FL": "Florida",
    "GA": "Georgia",
    "GU": "Guam",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MH": "Marshall Islands",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "MP": "Northern Mariana Islands",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PW": "Palau",
    "PA": "Pennsylvania",
    "PR": "Puerto Rico",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VI": "Virgin Islands",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming"
  },
  "publicKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuvVtc7QHsd73SuI+4yHJIQsFl4KrjlyYm4b4g9N8EGm184VnwD6ni82dG1O8JfouH83wsNXxBrBbJZ9AH708AUpm9lVzPZPN6+G7g5uUhkt4pskdLgG87ZUH3YQdYMljWE4IjRLLuel9zz+zGq7txPLzf/RExLzMFzATMp2HXmQkIOy7yQ4YbRGdJparTB8LasJoF2w+jhK25CK5lXOMH0fsd4Wl68aVWeSyYy8fRYNzwYTckFIg1iyB5wDYWWxXNa15t4hzg+CnauccPvTgxdSKJ9qWeX7733sfbIylIIvwfh/2vvJwnEukxD81IGEhBQkNlxDtrRsMWmpxsqK7swIDAQAB",
  "generalContent": {
    "new_line": "\n",
    "specialty_make_payment_sorry": "We're Sorry.",
    "specialty_make_payment_error": "There is 1 error in the form below.",
    "specialty_make_payment_partial_pay_full_amount": "Pay the full amount",
    "specialty_make_payment_partial_pay_partial_amount": "Make a partial payment",
    "specialty_make_payment_partial_payment": "A partial payment must be at least 1/3 of the total balance",
    "specialty_make_payment_partial_payment_balance": "A partial payment can't exceed the total balance",
    "specialty_account_review_payment_return": "Back",
    "specialty_account_bal_payment_back": "Back",
    "specialty_account_bal_payment_agree_continue": "Agree &amp; continue",
    "specialty_account_bal_payment_section_header": "Account Balance and Payment",
    "payment_global_error_header": "",
    "payment_global_error_intro": "",
    "payment_have_questions": "<p><b>Have questions?</b> Read our <a href=\"/wps/portal/specialty/patients/specialty-services/faq\">frequently asked questions</a> for more information about specialty prescription payments,</p><p>or <strong>call Billing toll-free at 1-800-250-9631.</strong></p>",
    "rest_content": "",
    "specialty_account_bal_payment_make_payment_now": "Make a payment",
    "specialty_account_bal_payment_register_make_payment_now": "Register to make payment",
    "specialty_account_bal_payment_disclaimer": "*This amount does not reflect orders that have not been shipped, that are pending insurance payment or that have been sent to an outside collections agency.",
    "specialty_account_bal_payment_make_onetime_payment_now": "Make a one-time payment",
    "specialty_account_bal_payment_switch_onetime_payment": "Deactivate Automatic Payments",
    "specialty_account_bal_payment_auto_payments": "Set Up Automatic Payments",
    "specialty_account_bal_payment_sorry_message": "We're Sorry.",
    "specialty_account_bal_payment_payment_error": "There is 1 error in the form below.",
    "specialty_account_bal_payment_make_payment_auto": "Your payment must be exactly your current balance",
    "specialty_account_bal_payment_balance_accrued": "As soon as a balance accrues.",
    "specialty_account_bal_payment_fsa": "If you pay with an FSA card, you will  be charged for the account balance on the same day every month, starting today. ",
    "specialty_account_bal_payment_date": "On a specific date each month. ",
    "specialty_account_bal_payment_limit": "If your balance is over this limit, we will charge the limit, then call to resolve the difference.",
    "specialty_account_bal_payment_charge": "Charge me up to",
    "specialty_payment_history_header": "Payment history",
    "specialty_payment_history_no_results_found": "You have no transactions in this time period.",
    "pymt_subhead_content": "Automatic Payment",
    "pageSize": "LETTER",
    "specialty_make_payment_enter_balance": "Please enter an amount in the payment field.",
    "specialty_make_payment_digit_error": "The payment amount can't exceed 8 digits and 2 decimal points.",
    "pymt_note_content": "We can schedule a payment on a specific day every month for either the full balance or an amount specified by you.",
    "specialty_make_payment_back": "Back",
    "specialty_make_payment_acc_bal_payment": "Return to Account balance & payment",
    "specilaty_automatic_payment_enabled": "Automatic payment",
    "specilaty_open_paymenthistory": "Open payment history report",
    "specilaty_open_paymenthistory_inapps": "Log in from web browser",
    "specialty_viewpayment_history_header": "View payment history",
    "specialty_viewpayment_history_desc": "View or save a PDF of your payment history for your personal records. The payment history can be used for insurance, taxes, or other financial purposes.",
    "specialty_viewpayment_history_desc_app": "View your payment history for insurance or other financial purposes. Note: You'll need to log in from a web browser to print or save your payment history from our Account Balance and Payment page."
  },
  "specialty_guest_payment": {
    "registration_promo": "<h3>Register for a CVS Specialty digital account. You're just one step away!</h3> <p>Here's what you can do: </p> <ul> <li>Refill prescriptions </li> <li>Track prescription shipments </li> <li>View your prescription history </li> <li>Set up repeating payments </li> <li>Use our mobile app to refill prescriptions on the go and set up prescription reminders </li> </ul>",
    "link_expire_headline": "ACCESS DENIED",
    "link_expire_intro": "For security purposes, access to this page was deactivated because the link has expired. <a href=\"/wps/portal/specialty/patients/registration\">Register for an account</a> to pay online, or call Billing toll-free at 1-800-250-9631 to pay by phone.",
    "multiple_id_headline": "PLEASE CALL US",
    "multiple_id_intro": "We have more than one record for you. Please call Billing at 1-800-250-9631 to pay your balance and resolve the issue."
  },
  "specialty_unauth_help": {
    "cc_payment_pleasenote": "You may not use a copay assistance or drug manufacturer's credit card to pay your balance online. If you'd prefer to use one of those payment methods, please call Billing toll-free at 1-800-250-9631.",
    "payment_approval_pleasenote": "We will call you for approval each time before withdrawing funds from your bank account."
  },
  "errorMessage": {
    "6001": "Please call Billing at 1-800-250-9631(TTY: 711) to pay your balance and resolve the issue.",
    "6008": "The account number is invalid. Please try again.",
    "6009": "<strong>We're sorry.</strong><br>This bank routing number is invalid. Please try again.",
    "6013": "<strong>We're sorry.</strong><br>You already created a repeating payment with this payment method.",
    "6018": "<strong>Action needed.</strong><br>You cannot use your flexible savings account (FSA) card to pay a balance from a prescription or service dating back 364 days or more. Choose a different payment method or call Billing toll-free at 1-800-250-9631.",
    "6019": "<strong>We're sorry.</strong><br>A partial payment must be at least 1/3 of the total balance",
    "6021": "<strong>We're sorry.</strong><br>Your credit card has expired. Please update the expiration date.",
    "6022": "<strong>We're sorry.</strong><br>Payments cannot start today. Choose another date.",
    "6621": "We have more than one record for you. Please call Billing at 1-800-250-9631 to pay your balance and resolve the issue.",
    "6622": "Please call Billing at 1-800-250-9631(TTY: 711) to pay your balance and resolve the issue.",
    "default": "<strong>We're sorry.</strong><br>There was an error processing your request. Please try again, or connect to our technical support team from our "
  },
  "submitPayV3ErrorMessage": {
    "ESLE0001": {"header":"We're sorry.", "message": "Unknown Error - Please contact the system administrator."},
    "ESLE0003": {"header":"We're sorry.", "message": "Unknown Error - Please contact the system administrator."},
    "MAKE_PMT_001": {"header":"We're sorry.", "message": "The patient id is invalid. Please try again."},
    "MAKE_PMT_004": {"header":"We're sorry.", "message": "Invalid payment request. Please try again."},
    "MAKE_PMT_005": {"header":"We're sorry.", "message": "The account number is invalid. Please try again."},
    "MAKE_PMT_006": {"header":"We're sorry.", "message": "This bank routing number is invalid. Please try again."},
    "MAKE_PMT_007": {"header":"We're sorry.", "message": "Your credit card has expired. Please update the expiration date."},
    "MAKE_PMT_008": {"header":"We're sorry.", "message": "Invalid payment request. Please try again."},
    "MAKE_PMT_009": {"header":"We're sorry.", "message": "Invalid payment request. Please try again."},
    "MAKE_PMT_010": {"header":"We're sorry.", "message": "You already created a repeating payment with this payment method."},
    "MAKE_PMT_011": {"header":"We're sorry.", "message": "Balance does not exists for Onetime Payment. Onetime payment cannot be used for future payments."},
    "MAKE_PMT_012": {"header":"We're sorry.", "message": "Past dues are available. Recurring payments can be only made for future payments."},
    "MAKE_PMT_013": {"header":"We're sorry.", "message": "Patient MOP Error."},
    "MAKE_PMT_015": {"header":"Action needed.", "message": "You cannot use your flexible savings account (FSA) card to pay a balance from a prescription or service dating back 364 days or more. Choose a different payment method or call Billing toll-free at 1-800-250-9631."},
    "MAKE_PMT_016": {"header":"We're sorry.", "message": "A partial payment must be at least 1/3 of the total balance."},
    "MAKE_PMT_017": {"header":"We're sorry.", "message": "Unable to transfer to self pay bill group from earlyout bill groups."},
    "MAKE_PMT_018": {"header":"We're sorry.", "message": "Your credit card has expired. Please update the expiration date."},
    "MAKE_PMT_019": {"header":"We're sorry.", "message": "Invalid payment request. Please try again."},
    "MAKE_PMT_020": {"header":"We're sorry.", "message": "ACH Acceptance Unavailable."},
    "MAKE_PMT_021": {"header": "Authorization/Verification for this card has been declined.", "message":" Unable to save this credit card.  Please contact your credit card provider. You can also check the information you entered, or select a different method to make this payment."}
  }
};